import React, { createContext, useContext, useState, ReactNode } from "react";

interface ExcelContextType {
  selectedItemId?: string;
  selectedItemInfo?: any;
  fileInfos?: any[];
  requiresPreset?: (itemId: string) => boolean;
  safetyManagePlan?: any;
  enviManagePlan?: any;
  scheduleData?: any;
  setSelectedItemId: (itemId?: string) => void;
  setSelectedItemInfo: (info?: any) => void;
  setFileInfos: (fileInfos?: any[]) => void;
  setRequiresPreset: (fn?: (itemId: string) => boolean) => void;
  setSafetyManagePlan: (plan?: any) => void;
  setEnviManagePlan: (plan?: any) => void;
  setScheduleData: (data?: any) => void;
}

const ExcelContext = createContext<ExcelContextType | undefined>(undefined);

interface ExcelProviderProps {
  children: ReactNode;
}

export const ExcelProvider: React.FC<ExcelProviderProps> = ({ children }) => {
  const [selectedItemId, setSelectedItemId] = useState<string>();
  const [selectedItemInfo, setSelectedItemInfo] = useState<any>();
  const [fileInfos, setFileInfos] = useState<any[]>();
  const [requiresPreset, setRequiresPreset] =
    useState<(itemId: string) => boolean>();
  const [safetyManagePlan, setSafetyManagePlan] = useState<any>();
  const [enviManagePlan, setEnviManagePlan] = useState<any>();
  const [scheduleData, setScheduleData] = useState<any>();

  const value: ExcelContextType = {
    selectedItemId,
    selectedItemInfo,
    fileInfos,
    requiresPreset,
    safetyManagePlan,
    enviManagePlan,
    scheduleData,
    setSelectedItemId,
    setSelectedItemInfo,
    setFileInfos,
    setRequiresPreset,
    setSafetyManagePlan,
    setEnviManagePlan,
    setScheduleData,
  };

  return (
    <ExcelContext.Provider value={value}>{children}</ExcelContext.Provider>
  );
};

export const useExcelContext = () => {
  const context = useContext(ExcelContext);
  return context; // undefined일 수 있으므로 optional로 반환
};

export default ExcelContext;
